function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0.625,0 L19.7411165,0 C19.9068768,2.18999637e-15 20.065848,0.065848025 20.1830583,0.183058262 L29.8169418,9.81694175 C29.934152,9.934152 30,10.0931232 30,10.2588835 L30,39.375 C30,39.7201779 29.7201779,40 29.375,40 L0.625,40 C0.279822031,40 4.22721094e-17,39.7201779 0,39.375 L0,0.625 C-4.22721094e-17,0.279822031 0.279822031,6.34081644e-17 0.625,0 Z",
  id: "path-1"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "database"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-15"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-14"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-13"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-12"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-11"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-10"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-9"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-8"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4"
}, /*#__PURE__*/React.createElement("g", {
  id: "Mask",
  fill: "#EFF4F6",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.625,0 L19.7411165,0 C19.9068768,2.18999637e-15 20.065848,0.065848025 20.1830583,0.183058262 L29.8169418,9.81694175 C29.934152,9.934152 30,10.0931232 30,10.2588835 L30,39.375 C30,39.7201779 29.7201779,40 29.375,40 L0.625,40 C0.279822031,40 4.22721094e-17,39.7201779 0,39.375 L0,0.625 C-4.22721094e-17,0.279822031 0.279822031,6.34081644e-17 0.625,0 Z",
  id: "path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "fold-Clipped"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "path-1"
}), /*#__PURE__*/React.createElement("rect", {
  id: "fold",
  fill: "#D5E1E5",
  fillRule: "nonzero",
  mask: "url(#mask-2)",
  x: 20,
  y: 0,
  width: 10,
  height: 10
}))))))))))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(7.500000, 12.500000)",
  fill: "#637282",
  fillRule: "nonzero",
  id: "Shape"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.8125,7.8125 C4.84375,7.8125 1.796875,7.265625 0,5.9375 L0,9.375 C0,11.484375 4.0625,12.5 7.8125,12.5 C11.5625,12.5 15.625,11.484375 15.625,9.375 L15.625,5.9375 C13.828125,7.265625 10.78125,7.8125 7.8125,7.8125 Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.8125,14.0625 C4.84375,14.0625 1.796875,13.515625 0,12.1875 L0,15.625 C0,17.734375 4.0625,18.75 7.8125,18.75 C11.5625,18.75 15.625,17.734375 15.625,15.625 L15.625,12.1875 C13.828125,13.515625 10.78125,14.0625 7.8125,14.0625 Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.8125,0 C4.0625,0 0,1.015625 0,3.125 C0,5.234375 4.0625,6.25 7.8125,6.25 C11.5625,6.25 15.625,5.234375 15.625,3.125 C15.625,1.015625 11.5625,0 7.8125,0 Z"
}))));

var SvgDatabase = function SvgDatabase(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "40px",
    viewBox: "0 0 30 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDatabase, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/database.73975547.svg";
export { ForwardRef as ReactComponent };